
        (() => {
            if (window.CartCrossSellLoaded) return;
            window.CartCrossSellLoaded = true;

            window.LastAddedProductId = null;

            async function getCart() {
            return fetch('/cart.js').then((r) => r.json());
            }

            const ADD_ORDER_KEY = 'crossSellAddOrder';

            function getAddOrder() {
                try {
                    return JSON.parse(sessionStorage.getItem(ADD_ORDER_KEY)) || [];
                } catch (e) {
                    return [];
                }
            }

            function setAddOrder(order) {
                try {
                    sessionStorage.setItem(ADD_ORDER_KEY, JSON.stringify(order));
                } catch (e) {}
            }

            // Records that productId was just added, most-recent last.
            function trackAddedProduct(productId) {
                const order = getAddOrder().filter(id => id !== productId);
                order.push(productId);
                setAddOrder(order);
            }

            // Shopify's cart.items order doesn't reliably reflect add-chronology
            // (e.g. after a size swap), so we track add order ourselves and just
            // filter it down to whatever is still in the cart.
            function getLatestRemainingProductId(cartIds) {
                const order = getAddOrder().filter(id => cartIds.includes(id));

                if (order.length) return order[order.length - 1];

                return cartIds.length ? cartIds[cartIds.length - 1] : null;
            }

            async function getRecommendations(productId) {
                const cart = await getCart();

                const cartIds = cart.items.map(i => i.product_id);

                const wrapper = document.querySelector(`.lineItem_cross_sell[data-product-id="${productId}"]`);

                if (!wrapper) return [];

                const products = Array.from(wrapper.querySelectorAll('span')).map(span => ({
                    id: Number(span.dataset.id),
                    url: span.dataset.url,
                    title: span.dataset.title,
                    price: Number(span.dataset.price),
                    featured_image: span.dataset.image,
                    available_variant_id: span.dataset.variantId
                }));

                return products
                    .filter(product => {

                        if (cartIds.includes(product.id)) return false;
                        if (!product.available_variant_id) return false;

                        return true;
                    })
                    .slice(0,3);
            }

            function money(price) {
            if (window.Shopify && Shopify.formatMoney) {
                return Shopify.formatMoney(price, window.themeVariables.settings.moneyFormat);
            }

            return '$' + (price / 100).toFixed(2);
            }

            function card(product) {
            const variantId = product.available_variant_id;  
            const productUrl = window.location.origin + product.url;
            return `
            <div class="complementary-products__product">

                <a href="${product.url}" class="complementary-products__image">

                    <img
                        src="${product.featured_image}"
                        alt="${product.title}"
                        loading="lazy">

                </a>

                <div class="ctm_pair_wrap">
                    <div class="ctm_pair_content">
                    <div class="look-swym-wrap">  
                        <a href="${product.url}">
                            ${product.title}
                        </a>
                        <button 
                          type="button"
                          aria-label="Add to Wishlist" 
                          class="swym-button swym-add-to-wishlist-view-product product_${product.id}" 
                          data-with-epi="true" 
                          data-swaction="addToWishlist" 
                          data-product-id="${product.id}" 
                          data-variant-id="${variantId}"
                          data-product-url="${productUrl}">
                        </button>
                      </div>

                        <div>${money(product.price)}</div>
                    </div>
                    <button
                        class="button button--small cross-sell-add"
                        data-variant-id="${variantId}">
                        Add to Cart
                    </button>

                </div>

            </div>`;
            }

            window.SwymCallbacks = window.SwymCallbacks || [];

            window.swymInitButtons = null;

            window.SwymCallbacks.push(function (swat) {
                window.swymInitButtons = function (container) {
                    swat.initializeActionButtons(container);
                };
            });

            async function render() {
            if (!window.LastAddedProductId) return;

            const targetProductId = window.LastAddedProductId;
            window.LastAddedProductId = null;

            const wrapper = document.querySelector('#dynamic-cross-sell');

            const list = document.querySelector('#dynamic-cross-sell-list');

            if (!wrapper || !list) return;

            const products = await getRecommendations(targetProductId);

            if (products.length === 0) {
                wrapper.hidden = true;

                list.innerHTML = '';

                return;
            }

            list.innerHTML = products.map(card).join('');

            wrapper.hidden = false;
            wrapper.style.display = 'block';

            if (window.swymInitButtons) {
                window.swymInitButtons("#dynamic-cross-sell");
            }
            }

            async function refreshAfterCartChange() {
            const cart = await getCart();

            const wrapper = document.querySelector('#dynamic-cross-sell');
            const list = document.querySelector('#dynamic-cross-sell-list');

            if (!wrapper || !list) return;

            // Cart is empty
            if (!cart.items.length) {
                window.LastAddedProductId = null;
                setAddOrder([]);
                list.innerHTML = '';
                wrapper.hidden = true;
                wrapper.style.display = 'none';
                return;
            }

            // Use the most recently added item that's still in the cart
            const cartIds = cart.items.map(i => i.product_id);
            window.LastAddedProductId = getLatestRemainingProductId(cartIds);
            render();
            }

            document.addEventListener('click', async function (event) {

                const button = event.target.closest('.cross-sell-add');

                if (!button) return;

                event.preventDefault();

                if (button.disabled) return;

                button.disabled = true;
                button.textContent = 'Adding...';

                try {

                    const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        id: button.dataset.variantId,
                        quantity: 1
                    })
                    });

                    const result = await response.json();

                    if (!response.ok) {
                        console.error(result);
                        throw new Error(result.description || 'Unable to add product');
                    }

                    // Let Prestige refresh the drawer
                    document.documentElement.dispatchEvent(
                    new CustomEvent('cart:refresh', {
                        bubbles: true
                    })
                    );

                    button.textContent = 'Added';

                } catch (error) {

                    console.error(error);

                    button.textContent = 'Error';

                }

                setTimeout(() => {

                    button.disabled = false;
                    button.textContent = 'Add to Cart';

                }, 1500);

                });

            document.addEventListener('variant:add', function (event) {
            if (!event.detail || !event.detail.items || !event.detail.items.length) {
                return;
            }

            // This is the exact product that was just added
            window.LastAddedProductId = event.detail.items[0].product_id;
            trackAddedProduct(window.LastAddedProductId);

            console.log('Newly added product:', window.LastAddedProductId);
            });

            document.addEventListener('cart-drawer:refreshed', async () => {
            const cart = await getCart();

            // If cart is empty
            if (!cart.items.length) {
                const wrapper = document.querySelector('#dynamic-cross-sell');
                const list = document.querySelector('#dynamic-cross-sell-list');

                if (wrapper) {
                wrapper.hidden = true;
                wrapper.style.display = 'none';
                }

                if (list) {
                list.innerHTML = '';
                }

                window.LastAddedProductId = null;
                setAddOrder([]);
                return;
            }

            // If recommendations were already set by variant:add (new add)
            if (window.LastAddedProductId) {
                render();
                return;
            }

            // Item removed or quantity changed - fall back to the most
            // recently added item that's still in the cart
            const cartIds = cart.items.map(i => i.product_id);
            window.LastAddedProductId = getLatestRemainingProductId(cartIds);

            render();
            });

            document.addEventListener('DOMContentLoaded', async () => {
            const cart = await getCart();

            if (cart.items.length) {
                const cartIds = cart.items.map(i => i.product_id);
                window.LastAddedProductId = getLatestRemainingProductId(cartIds);

                render();
            }
            });
        })();
 